import { useStaticQuery, graphql } from "gatsby";
import { Language } from "../../utils/localization/languages/types";

export function useGetTargetPagePath(language: Language): string {
  const targetSearchPagePath = useStaticQuery(graphql`
    query StaticTargetSearchPagePathQuery {
      allSitePage(
        filter: {
          context: { sanityId: { in: ["page-cruise", "drafts.page-cruise"] } }
        }
      ) {
        nodes {
          context {
            language {
              code
            }
          }
          path
        }
      }
    }
  `);

  const {
    allSitePage: { nodes: paths }
  } = targetSearchPagePath;
  const pathForLang = paths.find(
    (p) => p.context.language.code == language.code
  );
  return pathForLang?.path;
}
